module.exports = __webpack_public_path__ + "f0a9c447c86801d86bed6984b0d5cc5e.svg";